import { buildUrl } from '../requests';

export const loginUrl = buildUrl('/admins/token');
